(() => {
  "use strict";
  var e = {};

  function n(e, n) {
    for (var t = 0; t < n.length; t++) {
      var o = n[t];
      ((o.enumerable = o.enumerable || !1),
        (o.configurable = !0),
        "value" in o && (o.writable = !0),
        Object.defineProperty(e, o.key, o));
    }
  }
  ((e.n = (n) => {
    var t = n && n.__esModule ? () => n.default : () => n;
    return (
      e.d(t, {
        a: t,
      }),
      t
    );
  }),
    (e.d = (n, t) => {
      for (var o in t)
        e.o(t, o) &&
          !e.o(n, o) &&
          Object.defineProperty(n, o, {
            enumerable: !0,
            get: t[o],
          });
    }),
    (e.o = (e, n) => Object.prototype.hasOwnProperty.call(e, n)));
  const t = jQuery;
  var o = e.n(t);
  o()(document).ready(function () {
    document.addEventListener("touchstart", function () {}, !0);
    var e = new ((function () {
      function e() {
        (!(function (e, n) {
          if (!(e instanceof n))
            throw new TypeError("Cannot call a class as a function");
        })(this, e),
          (this.activeMenuCategory = null),
          (this.activeSubMenuCategory = null),
          (this.subMenuActive = !1),
          (this.initialMenuPosition = parseInt(
            o()(".site-header").outerHeight(!0),
            10,
          )),
          (this.categoryHoverActive = null));
      }
      var t, a, u;
      return (
        (t = e),
        (a = [
          {
            key: "handleMenuItemChange",
            value: function (e) {
              ((this.subMenuActive = !1),
                (this.activeMenuCategory = e),
                (this.activeSubMenuCategory = e));
            },
          },
          {
            key: "setSubMenuActive",
            value: function (e) {
              this.subMenuActive = e;
            },
          },
          {
            key: "setCategoryHoverActive",
            value: function (e) {
              this.categoryHoverActive = e;
            },
          },
          {
            key: "handleSubMenuLeave",
            value: function () {
              ((this.subMenuActive = !1), (this.activeSubMenuCategory = null));
            },
          },
          {
            key: "setSubMenuPosition",
            value: function (e) {
              var n = o()(
                '[data-top-menu-category-id="'.concat(e, '"]'),
              ).offset().left;
              o()(
                '[data-sub-menu-category-id="'.concat(
                  e,
                  '"]  > .main-menu__sub-menu',
                ),
              ).offset().left > n &&
                o()(
                  '[data-sub-menu-category-id="'.concat(
                    e,
                    '"]  > .main-menu__sub-menu',
                  ),
                ).css("margin-left", n);
            },
          },
          {
            key: "hideAll",
            value: function () {
              (this.setCategoryHoverActive(null),
                o()(".main-menu__sub-menu-container").addClass(
                  "main-menu__sub-menu-container--hidden",
                ),
                o()(".main-menu__sub-menu-container").attr(
                  "aria-hidden",
                  "true",
                ),
                o()("[data-sub-menu-category-id]").addClass(
                  "main-menu__sub-menu-wrapper--hidden",
                ),
                o()(".main-menu__sub-menu-container")
                  .find(".dropdown-item")
                  .attr("tabindex", "-1"),
                o()("[data-top-menu-category-id]").attr(
                  "aria-expanded",
                  "false",
                ));
            },
          },
          {
            key: "showSubMenuCategory",
            value: function (e) {
              (o()(".main-menu__sub-menu-container").removeClass(
                "main-menu__sub-menu-container--hidden",
              ),
                o()(".main-menu__sub-menu-container").attr(
                  "aria-hidden",
                  "false",
                ),
                o()("[data-sub-menu-category-id]").addClass(
                  "main-menu__sub-menu-wrapper--hidden",
                ),
                this.setSubMenuPosition(e),
                o()('[data-sub-menu-category-id="'.concat(e, '"]')).removeClass(
                  "main-menu__sub-menu-wrapper--hidden",
                ),
                o()('[data-sub-menu-category-id="'.concat(e, '"]'))
                  .find(".dropdown-item")
                  .attr("tabindex", "0"),
                o()('[data-top-menu-category-id="'.concat(e, '"]')).attr(
                  "aria-expanded",
                  "true",
                ));
            },
          },
        ]) && n(t.prototype, a),
        u && n(t, u),
        Object.defineProperty(t, "prototype", {
          writable: !1,
        }),
        e
      );
    })())();
    (o()(document).on("keydown", function (n) {
      "Escape" === n.key &&
        null !== e.categoryHoverActive &&
        (o()(
          '[data-top-menu-category-id="'.concat(e.activeMenuCategory, '"]'),
        ).focus(),
        e.hideAll());
    }),
      o()(".main-menu__close-sub-menu-button > i.material-icons").on(
        "click",
        function () {
          e.hideAll();
        },
      ),
      o()("#top-menu")
        .find(".dropdown-item")
        .bind("focus", function () {
          o()(this).data("top-menu-category-id") || e.hideAll();
        }),
      o()(".top-menu.mainmenu-dropdown")
        .find(".dropdown-item")
        .on("keydown", function (n) {
          "ArrowUp" === n.key &&
            (n.preventDefault(),
            o()(
              '[data-top-menu-category-id="'.concat(e.activeMenuCategory, '"]'),
            ).focus());
        }),
      o()("[data-top-menu-category-id]")
        .bind("focus touchstart mouseenter", function () {
          var n = o()(this),
            t = n.data("top-menu-category-id");
          (n.on("keydown", function (e) {
            "ArrowDown" === e.key &&
              (e.preventDefault(),
              o()(".top-menu.mainmenu-dropdown")
                .find(".dropdown-item:first")
                .focus());
          }),
            e.setCategoryHoverActive(t),
            setTimeout(function () {
              if (e.categoryHoverActive === t) {
                e.handleMenuItemChange(t);
                e.showSubMenuCategory(t);
              }
            }, 200));
        })
        .bind("mouseleave", function () {
          setTimeout(function () {
            (e.subMenuActive &&
              e.activeMenuCategory === e.activeSubMenuCategory) ||
              e.hideAll();
          }, 100);
        }),
      o()("[data-sub-menu-category-id] > .main-menu__sub-menu")
        .bind("focus touchstart mouseenter", function () {
          e.setSubMenuActive(!0);
        })
        .bind("mouseleave", function () {
          (e.handleSubMenuLeave(),
            setTimeout(function () {
              e.activeMenuCategory !== e.activeSubMenuCategory && e.hideAll();
            }, 300));
        }),
      o()(
        "li.mobile-menu-category > .mobile-menu-category__wrapper > .mobile-menu-category__dropdown",
      ).on("click", function () {
        var e = o()(this).parent().parent();
        e.hasClass("mobile-menu-category__dropdown--closed")
          ? e
              .removeClass("mobile-menu-category__dropdown--closed")
              .addClass("mobile-menu-category__dropdown--opened")
          : e.hasClass("mobile-menu-category__dropdown--opened") &&
            e
              .removeClass("mobile-menu-category__dropdown--opened")
              .addClass("mobile-menu-category__dropdown--closed");
      }));
  });
})();
